import { AuthClient, BearerAccessToken } from '@rhim/react';

import { environment } from '../environments/environment';
import { AxiosApi } from '../requests/axios-api';
import { LogRocket, useSessionURL } from './tracking';

export const authClient = new AuthClient({ ...environment, appName: 'apo-portal' });

authClient.interceptors.add('onBeforeLogout', async () => {
  await window.sessionStorage.clear();
});

export const Api = new AxiosApi(authClient);
Api.initializeSessionUrl(useSessionURL).catch((error: unknown) => {
  LogRocket.error('Failed to initialize the API LogRocket session URL.', error);
});
export const axiosApiInstance = Api.axiosApiInstance;

export async function getAuthToken(): Promise<BearerAccessToken> {
  const authInfo = await authClient.rehydrate();
  return authInfo.bearerAuthentication;
}
